// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-lis-wrapper {
  position: fixed;
  right: 24px;
  bottom: 20px;
  width: 320px;
}
.chat-lis-wrapper .open-modal-lis-sebrae {
  color: #fff;
  background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);
  justify-content: center;
  display: flex;
  align-items: center;
  height: inherit;
  font-size: 19px;
  border-radius: 18px 18px 0 18px;
  right: 24px;
  bottom: 115px;
  z-index: 16;
  position: fixed;
  padding: 12px 14px;
  gap: 8px;
  border: none;
}
.chat-lis-wrapper .open-modal-lis-sebrae img {
  width: 40px;
  object-fit: cover;
}
.chat-lis-wrapper .open-modal-lis-sebrae span {
  font-weight: 600;
  line-height: normal;
}
@media (max-width: 768px) {
  .chat-lis-wrapper .open-modal-lis-sebrae span {
    display: none;
  }
}
@media screen and (max-width: 576px) {
  .chat-lis-wrapper .open-modal-lis-sebrae {
    right: 15px;
    bottom: 75px;
    padding: 12px 14px;
  }
  .chat-lis-wrapper .open-modal-lis-sebrae span {
    display: none;
  }
}
.chat-lis-wrapper .modal-lis-sebrae {
  max-width: 380px;
  width: 100%;
  right: 70px;
  bottom: 0px;
  z-index: 16;
  position: fixed;
  border-radius: 4px 4px 0 0;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 360px;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background-color: var(--sebrae-white-5);
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message-list {
  flex: 1 1;
  display: flex;
  overflow-y: auto;
  padding: 8px 16px;
  flex-direction: column;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message-container {
  gap: 12px;
  display: flex;
  margin-top: auto;
  flex-direction: column;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis {
  gap: 8px;
  display: flex;
  padding: 4px;
  max-width: 90%;
  font-size: 16px;
  border-radius: 12px;
  align-items: flex-start;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis img {
  min-width: 38px;
  width: 38px;
  height: 38px;
  overflow: hidden;
  object-fit: contain;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble {
  font-size: 14px;
  text-align: left;
  min-height: 32px;
  padding: 8px 12px;
  border-radius: 4px;
  color: var(--sebrae-black-lighter);
  background: var(--sebrae-light-gray4);
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble.bubble-margin-top {
  margin-top: 6px;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble hr {
  margin: 8px 0;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble h3 {
  font-size: 14px;
  font-weight: 600;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble ul,
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble ol {
  margin: 10px 0;
  padding-left: 20px;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble li {
  margin-bottom: 6px;
  list-style-type: disc;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble p {
  margin-bottom: 10px;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble p:last-child {
  margin-bottom: 0;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .message.from-lis .message-bubble a {
  color: var(--sebrae-primary);
  text-decoration: underline;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .chat-input-area {
  display: flex;
  padding-top: 8px;
  padding: 16px 24px;
  border-top: 1px solid #ddd;
  background-color: var(--sebrae-white);
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .chat-input-area input {
  flex: 1 1;
  border: none;
  padding: 8px;
  outline: none;
  font-size: 16px;
  font-weight: 400;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-box .chat-input-area button {
  padding: 0;
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #555;
}
.chat-lis-wrapper .modal-lis-sebrae .message.from-user {
  align-self: flex-end;
  padding: 8px 12px;
  border-radius: 10px;
  max-width: 80%;
  font-size: 14px;
  color: #333;
  background-color: var(--sebrae-light-blue3);
}
.chat-lis-wrapper .modal-lis-sebrae .message.from-user p {
  margin: 0;
}
.chat-lis-wrapper .modal-lis-sebrae .message.from-user .message-bubble {
  text-align: left;
}
@media screen and (max-width: 576px) {
  .chat-lis-wrapper .modal-lis-sebrae {
    bottom: 0;
    right: 0px;
    z-index: 99;
    max-width: 100%;
  }
}
.chat-lis-wrapper .modal-lis-sebrae {
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-header {
  background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);
  color: white;
  display: flex;
  align-items: center;
  padding: 12px 22px;
  position: relative;
  gap: 10px;
  border-radius: 4px 4px 0 0;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-header span {
  max-width: 240px;
  text-align: left;
  font-size: 19px;
  line-height: 1.3;
  font-weight: 700;
  flex: 1 1;
}
.chat-lis-wrapper .modal-lis-sebrae .chat-header .close-chat {
  padding: 0;
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  color: white;
  font-size: 32px;
  cursor: pointer;
}
@media (min-width: 576px) {
  .chat-lis-wrapper {
    z-index: 99;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/chat-lis/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACF;AACE;EACE,WAAA;EACA,4DAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AACJ;AACI;EACE,WAAA;EACA,iBAAA;AACN;AAEI;EACE,gBAAA;EACA,mBAAA;AAAN;AAEM;EAJF;IAKI,aAAA;EACN;AACF;AAEI;EA/BF;IAgCI,WAAA;IACA,YAAA;IACA,kBAAA;EACJ;EACI;IACE,aAAA;EACN;AACF;AAGE;EACE,gBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;AADJ;AAGI;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,4BAAA;EACA,uCAAA;EACA,uCAAA;AADN;AAGM;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AADR;AAIM;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAFR;AAKM;EACE,QAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AAHR;AAKQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EAEA,gBAAA;EACA,mBAAA;AAJV;AAOQ;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,qCAAA;AALV;AAOU;EACE,eAAA;AALZ;AAQU;EACE,aAAA;AANZ;AASU;EACE,eAAA;EACA,gBAAA;AAPZ;AAUU;;EAEE,cAAA;EACA,kBAAA;AARZ;AAWU;EACE,kBAAA;EACA,qBAAA;AATZ;AAYU;EACE,mBAAA;AAVZ;AAYY;EACE,gBAAA;AAVd;AAcU;EACE,4BAAA;EACA,0BAAA;AAZZ;AAiBM;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qCAAA;AAfR;AAiBQ;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAfV;AAkBQ;EACE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AAhBV;AAqBI;EACE,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,2CAAA;AAnBN;AAqBM;EACE,SAAA;AAnBR;AAsBM;EACE,gBAAA;AApBR;AAwBI;EAhJF;IAiJI,SAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;EArBJ;AACF;AAwBE;EACE,iBAAA;EACA,uCAAA;EACA,gBAAA;AAtBJ;AAwBI;EACE,4DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,0BAAA;AAtBN;AA8BM;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AA5BR;AA+BM;EACE,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AA7BR;AAiCE;EAnPF;IAoPI,WAAA;EA9BF;AACF","sourcesContent":[".chat-lis-wrapper {\n  position: fixed;\n  right: 24px;\n  bottom: 20px;\n  width: 320px;\n\n  .open-modal-lis-sebrae {\n    color: #fff;\n    background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    height: inherit;\n    font-size: 19px;\n    border-radius: 18px 18px 0 18px;\n    right: 24px;\n    bottom: 115px;\n    z-index: 16;\n    position: fixed;\n    padding: 12px 14px;\n    gap: 8px;\n    border: none;\n\n    img {\n      width: 40px;\n      object-fit: cover;\n    }\n\n    span {\n      font-weight: 600;\n      line-height: normal;\n\n      @media (max-width: 768px) {\n        display: none;\n      }\n    }\n\n    @media screen and (max-width: 576px) {\n      right: 15px;\n      bottom: 75px;\n      padding: 12px 14px;\n\n      span {\n        display: none;\n      }\n    }\n  }\n\n  .modal-lis-sebrae {\n    max-width: 380px;\n    width: 100%;\n    right: 70px;\n    bottom: 0px;\n    z-index: 16;\n    position: fixed;\n    border-radius: 4px 4px 0 0;\n\n    .chat-box {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      height: 360px;\n      border-radius: 10px 10px 0 0;\n      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n      background-color: var(--sebrae-white-5);\n\n      .message-list {\n        flex: 1;\n        display: flex;\n        overflow-y: auto;\n        padding: 8px 16px;\n        flex-direction: column;\n      }\n\n      .message-container {\n        gap: 12px;\n        display: flex;\n        margin-top: auto;\n        flex-direction: column;\n      }\n\n      .message.from-lis {\n        gap: 8px;\n        display: flex;\n        padding: 4px;\n        max-width: 90%;\n        font-size: 16px;\n        border-radius: 12px;\n        align-items: flex-start;\n\n        img {\n          min-width: 38px;\n          width: 38px;\n          height: 38px;\n          //border-radius: 50%;\n          overflow: hidden;\n          object-fit: contain;\n        }\n\n        .message-bubble {\n          font-size: 14px;\n          text-align: left;\n          min-height: 32px;\n          padding: 8px 12px;\n          border-radius: 4px;\n          color: var(--sebrae-black-lighter);\n          background: var(--sebrae-light-gray4);\n\n          &.bubble-margin-top {\n            margin-top: 6px;\n          }\n\n          hr {\n            margin: 8px 0;\n          }\n\n          h3 {\n            font-size: 14px;\n            font-weight: 600;\n          }\n\n          ul,\n          ol {\n            margin: 10px 0;\n            padding-left: 20px;\n          }\n\n          li {\n            margin-bottom: 6px;\n            list-style-type: disc;\n          }\n\n          p {\n            margin-bottom: 10px;\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n          }\n\n          a {\n            color: var(--sebrae-primary);\n            text-decoration: underline;\n          }\n        }\n      }\n\n      .chat-input-area {\n        display: flex;\n        padding-top: 8px;\n        padding: 16px 24px;\n        border-top: 1px solid #ddd;\n        background-color: var(--sebrae-white);\n\n        input {\n          flex: 1;\n          border: none;\n          padding: 8px;\n          outline: none;\n          font-size: 16px;\n          font-weight: 400;\n        }\n\n        button {\n          padding: 0;\n          background: transparent;\n          border: none;\n          font-size: 18px;\n          cursor: pointer;\n          color: #555;\n        }\n      }\n    }\n\n    .message.from-user {\n      align-self: flex-end;\n      padding: 8px 12px;\n      border-radius: 10px;\n      max-width: 80%;\n      font-size: 14px;\n      color: #333;\n      background-color: var(--sebrae-light-blue3);\n\n      p {\n        margin: 0;\n      }\n\n      .message-bubble {\n        text-align: left;\n      }\n    }\n\n    @media screen and (max-width: 576px) {\n      bottom: 0;\n      right: 0px;\n      z-index: 99;\n      max-width: 100%;\n    }\n  }\n\n  .modal-lis-sebrae {\n    background: white;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n\n    .chat-header {\n      background: linear-gradient(45deg, #9285f9 0%, #cd5be8 100%);\n      color: white;\n      display: flex;\n      align-items: center;\n      padding: 12px 22px;\n      position: relative;\n      gap: 10px;\n      border-radius: 4px 4px 0 0;\n\n      //img {\n      //  width: 53.2px;\n      //  height: 53.2px;\n      //  border-radius: 50%;\n      //}\n\n      span {\n        max-width: 240px;\n        text-align: left;\n        font-size: 19px;\n        line-height: 1.3;\n        font-weight: 700;\n        flex: 1;\n      }\n\n      .close-chat {\n        padding: 0;\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        background: transparent;\n        border: none;\n        color: white;\n        font-size: 32px;\n        cursor: pointer;\n      }\n    }\n  }\n  @media (min-width: 576px) {\n    z-index: 99;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
